module.exports = __webpack_public_path__ + "img/1@s.184639dd.jpg";